import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../../Navigation/NavigationContainer';
import Validation from '../../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../../AdvWorkflowStep/AdvWorkflowStepContainer';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../HomePurchaseWorkflowConstants';
import AdvForm from '../../../../CommonComponents/AdvForm';
import InputDollar from '../../../InputDollar/InputDollarView';

export const withEmptyStringWhenNull = value => (value === null ? '' : value);

const HomeEstimatedValue = ({
  workflowId,
  branch,
  homeEstimatedValue,
  onChangeHomeEstimatedValue,
  doNotSave,
  homeEstimatedValueIsValid,
  stepValidator,
  nullableDownPayment,
  nullableHasPlanToGetMortgage,
  onPostProcess,
  onPostSave,
}) => (
  <AdvWorkflowStep branch={branch} workflowId={workflowId}>
    <Validation
      workflowId={workflowId}
      validationId={`${HOME_PURCHASE_GOAL_GRAPH_NODE}.MarketValue`}
    />
    <h2>What is the home&apos;s estimated value?</h2>
    <AdvForm>
      <ul className="horizontal">
        <li>
          <InputDollar
            isUnder
            className="md"
            placeholderClassName="adv-workflows-placeholder-large"
            placeholder="Market Value"
            value={withEmptyStringWhenNull(homeEstimatedValue)}
            onChange={onChangeHomeEstimatedValue(workflowId)}
            id="adv-market-value"
          />
        </li>
      </ul>
    </AdvForm>
    <Navigation
      nextIterators={[]}
      dirtyGraphNodes={[]}
      validator={stepValidator(homeEstimatedValueIsValid)}
      validationId={`${HOME_PURCHASE_GOAL_GRAPH_NODE}.MarketValue`}
      doNotSave={doNotSave}
      workflowId={workflowId}
      backendKey={HOME_PURCHASE_GOAL_GRAPH_NODE}
      onPostProcess={onPostProcess(nullableDownPayment, nullableHasPlanToGetMortgage)}
      onPostSave={onPostSave(workflowId)}
    />
  </AdvWorkflowStep>
);

HomeEstimatedValue.defaultProps = {
  nullableDownPayment: null,
  nullableHasPlanToGetMortgage: null,
};

HomeEstimatedValue.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: PropTypes.string.isRequired,
  onChangeHomeEstimatedValue: PropTypes.func.isRequired,
  onPostProcess: PropTypes.func.isRequired,
  onPostSave: PropTypes.func.isRequired,
  homeEstimatedValue: PropTypes.number.isRequired,

  homeEstimatedValueIsValid: PropTypes.bool.isRequired,
  stepValidator: PropTypes.func.isRequired,
  doNotSave: PropTypes.bool.isRequired,
  nullableDownPayment: PropTypes.number,
  nullableHasPlanToGetMortgage: PropTypes.bool,
};

export default HomeEstimatedValue;
